import React from "react";
import { Link } from "react-router-dom";

const Tags = ({ tags = [] }) => {
  console.log("🚀 ~ file: Tags.js:6 ~ Tags ~ tags:", tags);
  if (!tags) return null;
  const tagArray = tags instanceof Array ? tags : tags.split(",");
  return (
    <span style={{ marginLeft: "10px" }}>
      {tagArray.map((tag, i) => {
        const tagDisplay = tag.trim();
        return (
          <Link key={i} to={`/tag/${tagDisplay}`} title={tagDisplay}>
            {tagDisplay}
          </Link>
        );
      })}
    </span>
  );
};

export default Tags;
